__turbopack_context__.v({
  "alt": "auth-module__A_DBwq__alt",
  "brand": "auth-module__A_DBwq__brand",
  "card": "auth-module__A_DBwq__card",
  "details": "auth-module__A_DBwq__details",
  "error": "auth-module__A_DBwq__error",
  "field": "auth-module__A_DBwq__field",
  "fields": "auth-module__A_DBwq__fields",
  "form": "auth-module__A_DBwq__form",
  "hint": "auth-module__A_DBwq__hint",
  "nav": "auth-module__A_DBwq__nav",
  "navLinks": "auth-module__A_DBwq__navLinks",
  "page": "auth-module__A_DBwq__page",
  "row": "auth-module__A_DBwq__row",
  "signOut": "auth-module__A_DBwq__signOut",
  "submit": "auth-module__A_DBwq__submit",
  "success": "auth-module__A_DBwq__success",
});
